import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { useIdentityVerificationRedirect } from './hooks/useIdentityVerificationRedirect';

const IdentityVerificationRedirectPage = () => {
  const { hasRequiredParams, isSuccess, handleClick, isDuplicate } =
    useIdentityVerificationRedirect();

  if (!hasRequiredParams) return null;
  
  const titleText = isSuccess ? t('IdentityVerification.success') : t('IdentityVerification.fail');
  const imageName = isSuccess ? 'verfied.graphic' : 'attention';
  const buttonText = isSuccess ? t('next') : t('IdentityVerification.return');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] bg-background-light dark:bg-background-dark">
      <img src={`/assets/icons/${imageName}.png`} alt={imageName} className="w-[82px] h-[82px]" />
      <h1 className="text-[26px] font-bold text-text-main-lv1 leading-[31px] whitespace-pre-line text-center mt-[40px]">
        {titleText}
      </h1>
      {isDuplicate && (
        <p className="text-[15px] font-medium text-text-main-lv4 text-center mt-[14px]">
          {t('IdentityVerification.duplicated')}
        </p>
      )}
      <div className="fixed bottom-0 left-0 right-0 px-[24px] pb-[calc(env(safe-area-inset-bottom)+10px)]">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold leading-[20px] rounded-[18px]"
          onClick={handleClick}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default IdentityVerificationRedirectPage;
